import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // anchor links
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onClick);
    window.__lenis = lenis;

    // scroll to a URL hash on initial load (e.g. arriving from an email link like /#launch-cities).
    // Sections mount after async site-config loads, so retry until the element exists.
    if (window.location.hash && window.location.hash.length > 1) {
      const targetId = window.location.hash;
      let tries = 0;
      const tryScroll = () => {
        let el = null;
        try { el = document.querySelector(targetId); } catch { el = null; }
        if (el) {
          lenis.scrollTo(el, { offset: -80 });
        } else if (tries < 40) {
          tries += 1;
          setTimeout(tryScroll, 150);
        }
      };
      setTimeout(tryScroll, 300);
    }

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);
  return children;
}
